import * as angular from "angular";
import {IController} from "angular";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";

export class CustomOrderPlanningUploadsTableRowComponent implements IController {

  customOrderPlanningUpload: any;

  constructor(private commonsDialogService: CommonsDialogService) {
  }

  $onInit() {
  }

  onOpenFailedOrderExternalIdsDialog(event) {

    const items = this.customOrderPlanningUpload.failedOrderExternalIds.map(id => {
      return {id}
    })
    this.commonsDialogService.displayEntityLinksList(undefined, items, undefined, event);
  }

}

angular
  .module('bringoz.admin.order-planning-configuration')
  .component('customOrderPlanningUploadsTableRow', {
    bindings: {
      customOrderPlanningUpload: '<',
    },
    template: require('./custom-order-planning-uploads-table-row.html').default,
    controller: CustomOrderPlanningUploadsTableRowComponent
  });
